export default __webpack_public_path__ + "static/media/pending-withdrawals.f60aa2a1.svg";